const guiColors = {
    'motion-primary': '#6ed561',
    'motion-primary-transparent': '#6ed561e6',
    'motion-tertiary': '#4caf3f',

    'looks-secondary': '#6ed561',
    'looks-transparent': '#6ed56159',
    'looks-light-transparent': '#6ed56126',
    'looks-secondary-dark': '#4caf3f',

    'extensions-primary': 'hsla(115, 60%, 61%, 1)',
    'extensions-tertiary': 'hsla(115, 60%, 40%, 1)',
    'extensions-transparent': 'hsla(115, 60%, 61%, 0.35)',
    'extensions-light': 'hsla(115, 55%, 85%, 1)',

    'drop-highlight': '#9fe895'
};

const blockColors = {
    checkboxActiveBackground: '#6ed561',
    checkboxActiveBorder: '#4caf3f'
};

export {
    guiColors,
    blockColors
};
